module.exports = __webpack_public_path__ + "static/media/296355.a62a9e21.png";